module.exports = __webpack_public_path__ + "img/9788985635868.a3f9f2b6.jpg";